import { Table, TableProps } from "antd";
import { DataType } from "../../../models/interface/license.interface";
import { ColumnsTrial } from "./Column";
import PaginationComponent from "./Pagination";
import dayjs from "dayjs";

const App = ({
  data,
  total,
  rowSelection,
  currentPage,
  pageSize,
  requestedAtSortOrder,
  onTableChange,
  onResendActivationEmail,
}: {
  data: DataType[];
  total: number;
  rowSelection?: TableProps<DataType>["rowSelection"];
  currentPage: number;
  pageSize: number;
  requestedAtSortOrder: "ascend" | "descend" | null;
  onTableChange: TableProps<DataType>["onChange"];
  onResendActivationEmail: (licenseId: number) => Promise<void> | void;
}) => {
  return (
    <div className="border border-solid border-[#EBEEF2] rounded-lg">
      <Table<DataType>
        columns={ColumnsTrial(
          currentPage,
          pageSize,
          total,
          requestedAtSortOrder,
          onResendActivationEmail,
        )}
        rowSelection={rowSelection}
        dataSource={data}
        pagination={false}
        scroll={{ x: 1388 }}
        tableLayout="fixed"
        className="custom-table"
        rowKey={(record) => record.id?.toString() ?? ""}
        onChange={onTableChange}
        rowClassName={(record) => {
          if (!record.expiresAt) return "";
          const isNearExpiry =
            dayjs(record.expiresAt).diff(dayjs(), "day") < 90;
          return isNearExpiry ? "row-over-limit" : "";
        }}
        locale={{
          triggerAsc: "クリックして昇順にソート",
          triggerDesc: "クリックして降順にソート",
          cancelSort: "クリックしてソートを解除",
        }}
      />
      <PaginationComponent total={total} />
    </div>
  );
};

export default App;
